import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../pm-plugins/main';
import { addDiscardAllSuggestionsAnalytics } from '../ui/utils/analytics';
import { updateSuggestionStatus } from '../ui/utils/api';
import type { DiscardAllSuggestionsAction } from './types';

export const discardAllSuggestionsAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => DiscardAllSuggestionsAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(ids): boolean => {
		const state = api?.aiSuggestions?.sharedState.currentState();
		const suggestionById = state?.suggestionById;
		if (!suggestionById || suggestionById.size === 0) {
			return false;
		}

		const requestedIds = ids === undefined ? undefined : new Set(ids);
		const suggestions = Array.from(suggestionById.values()).filter(
			({ id }) => requestedIds === undefined || requestedIds.has(id),
		);
		if (suggestions.length === 0) {
			return false;
		}
		const discardedIds = suggestions.map(({ id }) => id);

		api?.core?.actions.execute(({ tr }) => {
			addDiscardAllSuggestionsAnalytics(api?.analytics?.actions)(tr, suggestions);
			tr.setMeta(
				aiSuggestionsPluginKey,
				requestedIds === undefined
					? { action: 'CLEAR_SUGGESTIONS' }
					: { action: 'REMOVE_SUGGESTIONS', ids: discardedIds },
			);
			api?.showDiff?.commands.hideDiff?.({ tr });
			return tr;
		});

		const updates = discardedIds.map((id) => ({ id, status: 'DISMISSED' as const }));

		updateSuggestionStatus({ updates });

		return true;
	};
